/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';

const Select = ({ value, defaultValue, options, onChange, ...props }: any) => {
    return (
        <select
            value={value}
            defaultValue={defaultValue}
            onChange={onChange}
            className='border border-gray-200 rounded-lg p-2 capitalize'
            {...props}
        >
            {options.map((opt: any) => (
                <option
                    key={opt.value}
                    value={opt.value}
                >{opt.name}</option>
            ))}
        </select>
    );
};

export default Select;